// key for data service or calls
export const DATA_SERVICE_KEY_INFRASTRUCTURE = 'infrastructure';
